// 全网热瓜 事件卡片数据（首页聚焦 · 后续与最新动态）

export interface GuaEvent {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  time: string;
  status: string;
  read: string;
  cover: string;
  points: number;
}

export const featuredEvents: GuaEvent[] = [
  {
    id: "e-azhe",
    tag: "带货翻车",
    title: "主播「阿哲严选」售假风波反转：第三方送检结果与平台判罚相悖",
    excerpt: "曾被指售假的直播带货头部主播，在最新一次第三方送检中产品显示合格，平台却维持原判罚，事件走向再度生变。",
    time: "2026.09.05 21:40",
    status: "更新中 · 二次反转",
    read: "4.2万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20online%20livestream%20shopping%20scene%20a%20delivery%20box%20overflowing%20with%20packaged%20products%20a%20magnifying%20glass%20inspecting%20goods%20warm%20cream%20background%20terracotta%20red%20accents%20newspaper%20collage%20aesthetic%20high%20detail&width=800&height=600&seq=cover-live-01&orientation=landscape",
    points: 2863,
  },
  {
    id: "e-geqian",
    tag: "解约纠纷",
    title: "顶流歌手与经纪公司解约风波，工作室深夜发声列三项诉求",
    excerpt: "合作七年的歌手与经纪公司爆发解约纠纷，工作室深夜发声，详细罗列版权归属、分成比例与艺人自由三项核心诉求。",
    time: "2026.09.04 23:15",
    status: "当事人已回应",
    read: "3.1万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20celebrity%20agency%20contract%20dispute%20two%20elegant%20hands%20pulling%20opposite%20ends%20of%20a%20long%20paper%20contract%20torn%20in%20the%20middle%20warm%20cream%20background%20deep%20red%20and%20amber%20duotone%20newspaper%20collage%20style%20high%20detail&width=800&height=600&seq=cover-star-02&orientation=landscape",
    points: 2410,
  },
  {
    id: "e-laoyang",
    tag: "抄袭争议",
    title: "探店博主「老杨逛吃」被指抄袭，粉丝扒出三年的同款视频模板",
    excerpt: "凭借固定开场走红的探店博主，被同行控诉脚本与运镜高度雷同，评论区出现大量三年期对比截图。",
    time: "2026.09.03 19:05",
    status: "反转中 · 证据待核",
    read: "2.7万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20food%20blogger%20plagiarism%20two%20identical%20plates%20of%20noodles%20side%20by%20side%20a%20fork%20and%20a%20copy%20icon%20above%20warm%20cream%20background%20orange%20and%20rust%20accents%20newspaper%20collage%20aesthetic%20high%20detail&width=800&height=600&seq=cover-food-03&orientation=landscape",
    points: 2194,
  },
  {
    id: "e-dianjing",
    tag: "转会乌龙",
    title: "电竞选手转会闹乌龙：俱乐部承认是「内部流程失误」，本人已删博",
    excerpt: "早前被官宣加盟的电竞选手，一夜之间被另一家俱乐部抢先公布，官方随后致歉称系内部操作失误。",
    time: "2026.09.02 14:30",
    status: "已澄清",
    read: "1.9万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20esports%20player%20transfer%20news%20a%20game%20controller%20crossed%20with%20a%20curved%20transfer%20arrow%20and%20a%20question%20mark%20badge%20warm%20cream%20background%20deep%20red%20and%20amber%20duotone%20newspaper%20collage%20style%20high%20detail&width=800&height=600&seq=cover-game-04&orientation=landscape",
    points: 1876,
  },
  {
    id: "e-geshou",
    tag: "音乐争议",
    title: "素人爆款单曲被质疑借鉴，制作人晒工程文件自证原创",
    excerpt: "一首爆红网络的素人单曲陷入借鉴风波，制作人连夜公布工程文件时间戳，试图证明创作完全独立。",
    time: "2026.09.01 20:12",
    status: "当事人已回应",
    read: "1.6万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20hit%20song%20plagiarism%20dispute%20overlapping%20music%20notes%20and%20a%20microphone%20with%20a%20balance%20scale%20warm%20cream%20background%20terracotta%20red%20accents%20newspaper%20collage%20aesthetic%20high%20detail&width=800&height=600&seq=cover-song-05&orientation=landscape",
    points: 1542,
  },
  {
    id: "e-lianming",
    tag: "营销翻车",
    title: "某品牌联名被指「借壳营销」，网友晒出新旧款对比直呼割韭菜",
    excerpt: "全新发售的限量联名被扒出与旧款高度相似，仅换包装与配色，品牌方暂未正面回应，讨论持续升温。",
    time: "2026.08.31 16:48",
    status: "持续发酵",
    read: "1.3万阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20brand%20marketing%20controversy%20milk%20bottles%20pouring%20onto%20the%20floor%20with%20a%20broken%20heart%20speech%20bubble%20warm%20cream%20background%20rust%20orange%20and%20deep%20red%20duotone%20newspaper%20collage%20style%20high%20detail&width=800&height=600&seq=cover-brand-06&orientation=landscape",
    points: 1288,
  },
];